const React = require('react');

function useMountedState() {
  const isMounted = React.useRef(false);

  React.useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
}

function useAsyncSafeState(...args) {
  const isMounted = useMountedState();
  const [value, setValue] = React.useState(...args);
  const asyncSafeSetValue = React.useCallback((newValue) => {
    if (isMounted.current) {
      return setValue(newValue);
    }
    // eslint-disable-next-line
  }, []);

  return [value, asyncSafeSetValue];
}

module.exports = useAsyncSafeState;
